<template>
  <div class="progress-tracker">
    <slot />
  </div>
</template>

<style>
.progress-tracker {
  padding: 0;
}
</style>

<script>
export default {
  name: 'ProgressTracker'
}
</script>